import adventureImg from "./img/adventure.png";
import animationImg from "./img/animation.png";
import biographicalImg from "./img/biographical.png";
import comedyImg from "./img/comedy.png";
import crimeImg from "./img/crime.png";
import documentaryImg from "./img/documentary.png";
import dramaImg from "./img/drama.png";
import familyImg from "./img/family.png";
import fantasyImg from "./img/fantasy.png";
import historicalImg from "./img/historical.png";
import horrorImg from "./img/horror.png";
import musicalImg from "./img/musical.png";
import mysteryImg from "./img/mystery.png";
import romanceImg from "./img/romance.png";
import sciFiImg from "./img/sci-fi.png";
import superheroImg from "./img/superhero.png";
import thrillerImg from "./img/thriller.png";
import warImg from "./img/war.png";
import westernImg from "./img/western.png";

import React, {useEffect, useRef, useState} from "react";
import styles from "./preferences-genre.module.css";
import texts from "../../assets/ContextProvider/textsLocalized.json"


const PreferencesGenre = ({
                            selectedPreferences,
                            setSelectedPreferences,
                            isUnselectedRequiredCategory,
                            setIsUnselectedRequiredCategory
                          }) => {
  const buttonTypes = [
    {
      genreLocal: "Adventure",
      genre: {'tv': 'Action & Adventure', 'movie': 'Adventure'},
      context: texts.preferences["btn-adventure"],
      imgPath: adventureImg
    },
    {
      genreLocal: "Animation",
      genre: {'tv': 'Animation', 'movie': 'Animation'},
      context: texts.preferences["btn-animation"],
      imgPath: animationImg
    },
    {
      genreLocal: "Biographical",
      genre: {'tv': 'Reality', 'movie': 'Documentary'},
      context: texts.preferences["btn-biographical"],
      imgPath: biographicalImg
    },
    {
      genreLocal: "Comedy",
      genre: {'tv': 'Comedy', 'movie': 'Comedy'},
      context: texts.preferences["btn-comedy"],
      imgPath: comedyImg
    },
    {
      genreLocal: "Crime",
      genre: {'tv': 'Crime', 'movie': 'Crime'},
      context: texts.preferences["btn-crime"],
      imgPath: crimeImg
    },
    {
      genreLocal: "Documentary",
      genre: {'tv': 'Documentary', 'movie': 'Documentary'},
      context: texts.preferences["btn-documentary"],
      imgPath: documentaryImg
    },
    {
      genreLocal: "Drama",
      genre: {'tv': 'Drama', 'movie': 'Drama'},
      context: texts.preferences["btn-drama"],
      imgPath: dramaImg
    },
    {
      genreLocal: "Family",
      genre: {'tv': 'Family', 'movie': 'Family'},
      context: texts.preferences["btn-family"],
      imgPath: familyImg
    },
    {
      genreLocal: "Fantasy",
      genre: {'tv': 'Sci-Fi & Fantasy', 'movie': 'Fantasy'},
      context: texts.preferences["btn-fantasy"],
      imgPath: fantasyImg
    },
    {
      genreLocal: "Historical",
      genre: {'tv': 'War & Politics', 'movie': 'History'},
      context: texts.preferences["btn-historical"],
      imgPath: historicalImg
    },
    {
      genreLocal: "Horror",
      genre: {'tv': 'Mystery', 'movie': 'Horror'},
      context: texts.preferences["btn-horror"],
      imgPath: horrorImg
    },
    {
      genreLocal: "Musical",
      genre: {'tv': 'Kids', 'movie': 'Music'},
      context: texts.preferences["btn-musical"],
      imgPath: musicalImg
    },
    {
      genreLocal: "Mystery",
      genre: {'tv': 'Mystery', 'movie': 'Mystery'},
      context: texts.preferences["btn-mystery"],
      imgPath: mysteryImg
    },
    {
      genreLocal: "Romance",
      genre: {'tv': 'Soap', 'movie': 'Romance'},
      context: texts.preferences["btn-romance"],
      imgPath: romanceImg
    },
    {
      genreLocal: "Sci-Fi",
      genre: {'tv': 'Sci-Fi & Fantasy', 'movie': 'Science Fiction'},
      context: texts.preferences["btn-sci-fi"],
      imgPath: sciFiImg
    },
    {
      genreLocal: "Superhero",
      genre: {'tv': 'Sci-Fi & Fantasy', 'movie': 'Action'},
      context: texts.preferences["btn-superhero"],
      imgPath: superheroImg
    },
    {
      genreLocal: "Thriller",
      genre: {'tv': 'Drama', 'movie': 'Thriller'},
      context: texts.preferences["btn-thriller"],
      imgPath: thrillerImg
    },
    {
      genreLocal: "War",
      genre: {'tv': 'War & Politics', 'movie': 'War'},
      context: texts.preferences["btn-war"],
      imgPath: warImg
    },
    {
      genreLocal: "Western",
      genre: {'tv': 'Western', 'movie': 'Western'},
      context: texts.preferences["btn-western"],
      imgPath: westernImg
    },
  ];
  const timeoutGenreRef = useRef(null);


  const handleChangeGenre = (e) => {
    const selectedGenre = buttonTypes[e.currentTarget.dataset.preferencesGenreIndex].genre;
    const selectedGenreLocal = e.currentTarget.dataset.preferencesGenreLocal;
    const isSelected = selectedPreferences.genreLocal.includes(selectedGenreLocal);
    let updatedGenresLocal;
    let updatedGenres;

    if (isSelected) {
      updatedGenresLocal = selectedPreferences.genreLocal.filter((genre) => genre !== selectedGenreLocal);
      updatedGenres = selectedPreferences.genre
        .filter((genre) => JSON.stringify(genre) !== JSON.stringify(selectedGenre));
    } else {
      if (selectedPreferences.genreLocal.length >= 3) return;
      updatedGenresLocal = [...selectedPreferences.genreLocal, selectedGenreLocal];
      updatedGenres = [...selectedPreferences.genre, selectedGenre];
    }

    setSelectedPreferences((prev) => ({
      ...prev,
      genreLocal: updatedGenresLocal,
      genre: updatedGenres
    }));
  };


  useEffect(() => {
    timeoutGenreRef.current = setTimeout(() => {
      setIsUnselectedRequiredCategory(prev => ({...prev, genre: false}));
    }, 1250);

    return () => {
      clearTimeout(timeoutGenreRef.current);
    }
  }, [isUnselectedRequiredCategory.genre]);


  return (
    <>
      <div className={`${styles["preferences-genre-title"]}
                       ${isUnselectedRequiredCategory.genre ? `${styles["unselected"]}` : ""}`}>
        {texts.preferences.genre}
        <div className={styles["preferences-genre-counter-container"]}>
                  <span className={
                    `${styles["preferences-genre-counter"]}
                     ${selectedPreferences.genreLocal.length === 3 ?
                      `${styles["preferences-genre-counter-limit"]}` : ''}`}>
          {selectedPreferences.genreLocal.length}/3
        </span>
        </div>
      </div>
      <div className={styles["preferences-genre-container"]}>
        <div className={styles["preferences-genre-btn-container"]}>
          {buttonTypes.map((item, index) => {
            return (
              <button
                key={index}
                className={
                  `${styles["preferences-genre-btn"]} 
                   ${selectedPreferences.genreLocal.includes(item.genreLocal) ?
                    `${styles["active"]} ${styles["preferences-genre-btn-selected"]}` : ""}
                    `}
                onClick={handleChangeGenre}
                data-preferences-genre-local={item.genreLocal}
                data-preferences-genre-index={index}>
                {item.context}
                <img className={styles["preferences-genre-img"]}
                     src={item.imgPath}
                     alt="emoji"/>
              </button>)
          })}
        </div>
      </div>
    </>
  )
}

export default PreferencesGenre;